// extracted by mini-css-extract-plugin
export var container = "styles-module--container--Dd9HA";
export var sectionDownload = "styles-module--sectionDownload--eXD3s";
export var imgAppStore = "styles-module--imgAppStore--YY+TY";
export var imgBanner = "styles-module--imgBanner--OfsCw";
export var sectionImgBanner = "styles-module--sectionImgBanner--NLBql";
export var button = "styles-module--button--biF6K";
export var buttonsContainer = "styles-module--buttonsContainer--zrcHF";